/**
 * Répartition des comptes bancaires entre trésorerie disponible et argent engagé.
 *
 * Deux notions distinctes (cf. migration 0068) :
 *   - operating    : trésorerie DISPONIBLE, utilisable pour l'exploitation
 *   - sinking_fund : argent mis de côté pour rembourser une dette — il t'appartient
 *                    encore, mais il n'est plus à toi
 *
 * Source de vérité partagée : le backend ne peut pas corriger les sommes calculées
 * côté client, et elles étaient dupliquées dans BalanceCard et CashFlowHeaderKPIs.
 * Tout nouveau consommateur du solde doit passer par ici.
 *
 * `purpose` peut être absent le temps d'un déploiement (ancien contrat d'API) :
 * on retombe alors sur 'operating', c'est-à-dire le comportement historique.
 *
 * @param {Array<{balance_cents: number|null, purpose?: string}>} accounts
 * @returns {{ operating, sinkingFunds, operatingCents, sinkingCents, totalCents }}
 */
export function splitByPurpose(accounts = []) {
  const list = Array.isArray(accounts) ? accounts : [];
  const isSinking = (a) => a.purpose === 'sinking_fund';

  const operating    = list.filter((a) => !isSinking(a));
  const sinkingFunds = list.filter(isSinking);
  const sum = (arr) => arr.reduce((s, a) => s + (a.balance_cents ?? 0), 0);

  const operatingCents = sum(operating);
  const sinkingCents   = sum(sinkingFunds);

  return {
    operating,
    sinkingFunds,
    operatingCents,
    sinkingCents,
    totalCents: operatingCents + sinkingCents,
  };
}
